module.exports = __webpack_public_path__ + "static/media/cny_3.24d7e667.jpg";